/* eslint-disable max-len */
import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/dato-de-pago-del-becario';

export const getDatosDePagoDeBecarios = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getDatoDePagoDelBecario = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

export const postDatoDePagoDelBecario = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const patchDatoDePagoDelBecario = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const deleteDatoDePagoDelBecario = async (id) => {
  try {
    await API.delete(`${baseURI}/${id}`);
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const putDatoDePagoDelBecario = async (values) => {
  try {
    const response = await API.put(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
